import { useMutation, useQueryClient } from "@tanstack/react-query";
import { testingAxios, testingAuthHeaders } from "@/services/testing";
import { runAbortEndpoint } from "@/services/testing";

async function abortRun(runId: string): Promise<{ run_id: string; signaled: boolean }> {
  const r = await testingAxios.post<{ run_id: string; signaled: boolean }>(
    runAbortEndpoint(runId),
    {},
    { headers: testingAuthHeaders() }
  );
  return r.data;
}

export function useAbortRun() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: abortRun,
    // Once the abort is acknowledged the run's terminal status is written server-side. Refetch the
    // history so it stops showing "running" and flips to its final state immediately, rather than
    // waiting for the next poll tick. (Ported from Shrey's ebefb8b6.)
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: ["testingRuns"] });
    },
  });
}
